<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Wurden die Fenster in Ihrer Wohnung modernisiert?
            </h1>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="modernisierteFenster">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" v-html="getConflictText()"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected">
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('modernisierteFenster.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText(item.errorTypes, item.error, item.id)" v-html="getErrorText(item.errorTypes, item.error, item.id)"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-html="$t('modernisierteFenster.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Modernisierte Fenster</h3><br/>
                            <p>Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei der alle Fenster 1995 oder später eingebaut wurden und 2019 oder später mindestens die Hälfte der Fenster von der*dem Vermieter*in modernisiert beziehungsweise instandgesetzt wurden.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { mapActions, createNamespacedHelpers } from 'vuex';

    const { mapMutations, mapState } = createNamespacedHelpers('error')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a modernisierterFENSTER ERROR
        computed: { ...mapState(['modernisierteFenster']),
                    ...mapGetters(['hasPermission'])},
        methods: { ...mapActions('berechnung', ['SELECT_MODERNISIERTEFENSTER']),
                  ...mapActions('error', ['CHECK_GEBAEUDETYP_ERROR']),
                  ...mapActions('error', ['CHECK_HAUSTYP_ERROR']),
                  ...mapActions('error', ['CHECK_BAUJAHR_ERROR']),
                  ...mapMutations(['SET_MODERNISIERTEFENSTER_ERROR'])}
    })
    export default class ModernisierteFenster extends Vue {

         get error(){
             return this.hasError(this.selectedData.error)
         }

         get selectedData(){
             return this.items.filter(item => item.id === this.selectedItem)[0]
         }

        data() {
            return {
                index: 14,
                selectedItem: this.$store.state.berechnung.selectedModernisierteFenster,
                items: [
                    { id: 0,
                      error: {
                          selectedBaujahr: function(el){ return el >= 3 },
                          selectedGebaeudetyp: function(el){return el == 0},
                          selectedHaustyp: function(el){return el == 3}
                      },
                      errorTypes: [
                        "Baujahr",
                        "Gebaeudetyp",
                        "Haustyp",
                      ]
                    },
                    { divider: true},
                    { id: 1},
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(errorTypes, error, id){
            /*
             * select those errorTypes (= different components), whose selected value
             * in the store is matched by the function at the same index in error (of the item)
             */
            let errorType = errorTypes.filter((_, i) => error[Object.keys(error)[i]](this.$store.state.berechnung[Object.keys(error)[i]]));
            return errorType.map(el => this.$t('warning.select',
                { step: this.$t(el),
                  choice: this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' +
                          this.$store.state.berechnung['selected' + el]),
                  currentStep: "von ",
                  currentChoice: this.$t('modernisierteFenster.' + id)
                })).join("<br/>");
        }

        //when conflict is present its text is depending on the item in the store, not the current selection
        getConflictText(){
            let conflictItem = this.items.filter(item => item.id === this.$store.state.berechnung.selectedModernisierteFenster)[0]
            return this.getErrorText(conflictItem.errorTypes, conflictItem.error, conflictItem.id)
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedData.id)
            this.SELECT_MODERNISIERTEFENSTER({ selectedModernisierteFenster: this.selectedItem, selectedModernisierteFensterError: this.selectedData.error })
            this.CHECK_GEBAEUDETYP_ERROR()
            this.CHECK_HAUSTYP_ERROR()
            this.CHECK_BAUJAHR_ERROR()
            if(this.error){
                console.log('found modernisierteFenster error')
                this.SET_MODERNISIERTEFENSTER_ERROR(true)
                let alert = document.querySelector('.errors')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            } else {
                this.SET_MODERNISIERTEFENSTER_ERROR(false)
                this.$router.push('abweichungen')
            }
        }

        back() {
            this.$router.push('ausstattung')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
